import { render, staticRenderFns } from "./customersSOA.vue?vue&type=template&id=23e3ab55&"
import script from "./customersSOA.vue?vue&type=script&lang=js&"
export * from "./customersSOA.vue?vue&type=script&lang=js&"
import style0 from "./customersSOA.vue?vue&type=style&index=0&lang=css&"
import style1 from "./customersSOA.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports